import { createTheme as r } from "flowbite-react";
const a = r({
  alert: {
    color: {
      info: "border-cyan-500 bg-cyan-100 text-cyan-700 dark:bg-cyan-200 dark:text-cyan-800  dark:border-cyan-400",
      failure: "border-red-500 bg-red-100 text-red-700 dark:bg-red-200 dark:text-red-800 dark:border-red-400",
      success: "border-green-500 bg-green-100 text-green-700 dark:bg-green-200 dark:text-green-800 dark:border-green-400",
      warning: "border-yellow-500 bg-yellow-100 text-yellow-700 dark:bg-yellow-200 dark:text-yellow-800 dark:border-yellow-400",
      dark: "border-gray-600 bg-gray-800 text-gray-200 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-400",
      light: "border-gray-400 bg-gray-50 text-gray-600 dark:bg-gray-500 dark:text-gray-200 dark:border-gray-600"
    }
  }
}).alert;
export {
  a as theme
};
